<div class="bcg p-4">
  <!-- ── Breadcrumb + Branch selector ─────────────────────────────────────── -->
  <div class="row">
    <div class="col-lg-8 col-sm-6 col-md-6">
      <nav class="custom-nav">
        <ol class="breadcrumb">
          <li class="breadcrumb-item clickable" (click)="back()">Dashboard</li>
          <li class="breadcrumb-item active">CAT Compose</li>
        </ol>
      </nav>
    </div>
    <div *ngIf="showCompose" class="col-lg-4 col-sm-6 col-md-6">
      <app-select-branch
        (OnBranchChangeData)="changeState($event)"
      ></app-select-branch>
    </div>
  </div>

  <!-- ── Title card ─────────────────────────────────────────────────────────── -->
  <div *ngIf="showCompose" class="card card_outLine mt-2">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-9 col-sm-8 col-md-8">
          <h5 class="title_header_0 mb-0">CAT Compose</h5>
          <p class="card-text text_p mb-0">
            e-Stamp &amp; eSign documents on the Cloud
          </p>
        </div>
        <div class="col-lg-3 col-sm-4 col-md-4 text-right custom_button">
          <p-button
            label="Back"
            (click)="back()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Stepper ────────────────────────────────────────────────────────────── -->
  <div class="card mt-3 card_style_bs_order_cat card_outLine">
    <div class="card-body" style="padding-bottom: 0">
      <div class="title_header_0">Finish Setting Up in Five Simple Steps</div>
      <ul class="row steps_style" style="padding-left: 10px">
        <li
          [ngClass]="[
            active_compose ? 'box-item_active' : '',
            showCompose ? 'boxOutline' : 'box-item',
          ]"
          class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          (click)="showCompose ? gotoScreen('compose') : null"
        >
          1. Select &amp; Compose
        </li>
        <li
          [ngClass]="[
            active_template ? 'box-item_active' : '',
            showEditTemplate ? 'boxOutline' : 'box-item',
            productDetailsData == undefined ? 'noclick' : '',
          ]"
          class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          (click)="showEditTemplate ? gotoScreen('editTemplate') : null"
        >
          2. Edit template
        </li>
        <li
          [ngClass]="[
            active_eStamp ? 'box-item_active' : '',
            showEstampDetails ? 'boxOutline' : 'box-item',
            productDetailsData == undefined || editTemplateData == undefined
              ? 'noclick'
              : '',
          ]"
          class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          (click)="showEstampDetails ? gotoScreen('estamp') : null"
        >
          3. E-stamp details
        </li>
        <li
          [ngClass]="[
            active_eSign ? 'box-item_active' : '',
            showEsignDetails ? 'boxOutline' : 'box-item',
            productDetailsData == undefined ||
            editTemplateData == undefined ||
            estampData == undefined
              ? 'noclick'
              : '',
          ]"
          class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          (click)="showEsignDetails ? gotoScreen('esign') : null"
        >
          4. Signing details
          <span *ngIf="!esignData.toBeEsigned">(skipped)</span>
        </li>
        <li
          [ngClass]="[
            active_confirm ? 'box-item_active' : '',
            showConfirmation ? 'boxOutline' : 'box-item',
            'noclick',
          ]"
          class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
        >
          5. Order confirmation
        </li>
      </ul>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       STEP 1 — Select & Compose
       ══════════════════════════════════════════════════════════════════════════ -->
  <!-- Bulk upload hint links (disabled for CAT Compose for now)
  <div *ngIf="showEstampDetails" class="text-right m-2">
    <p class="text_p">
      Try
      <a
        class="btn-link clickable link_text"
        [routerLink]="['/doqfy/bulk-upload']"
        >Bulk Upload</a
      >
      if you have more than 5 stamp details
    </p>
  </div>
  <div *ngIf="showEditTemplate" class="text-right">
    <p class="text_p_6">
      Try
      <a
        class="btn-link clickable link_text_1"
        [routerLink]="['/doqfy/bulk-upload']"
        >Bulk Upload</a
      >
      if you have more than 5 stamp details
    </p>
  </div>
  -->

  <!-- ══════════════════════════════════════════════════════════════════════════
       STEP 1 — Select & Compose
       ══════════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="showCompose">
    <!-- Form fields -->
    <div class="card card_outLine mt-3">
      <div class="card-body">
        <form [formGroup]="composeForm">
          <div class="row">
            <!-- Branch (read-only) -->
            <div class="col-lg-3 col-sm-4 col-md-4">
              <span class="form_field">Branch</span>
              <div class="custom-input">
                <input
                  class="readOnly grey_background"
                  type="text"
                  pInputText
                  readOnly="true"
                  formControlName="branchName"
                />
                <span class="p-error" style="font-size: 0.5rem" *ngIf="noBranch"
                  >Please select a branch</span
                >
              </div>
            </div>
            <!-- Reference Number -->
            <div class="col-lg-3 col-sm-4 col-md-4">
              <span class="form_field">
                {{
                  showHdfcFields
                    ? "File number (As per HDFC Bank Sanction letter)"
                    : "Reference Number"
                }}
                <span class="color_red">*</span>
              </span>
              <div class="custom-input">
                <input
                  type="text"
                  pInputText
                  formControlName="referenceNumber"
                  placeholder="Allows alphabets, numbers and hyphen"
                  [ngClass]="enableRefIdField ? '' : 'grey_background'"
                  [readOnly]="!enableRefIdField"
                  (paste)="onReferencePaste($event)"
                  onkeypress="
                    return (
                      (event.charCode >= 65 && event.charCode <= 90) ||
                      (event.charCode >= 97 && event.charCode <= 122) ||
                      (event.charCode >= 48 && event.charCode <= 57) ||
                      event.charCode === 45 ||
                      event.charCode === 95
                    );
                  "
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    composeForm.get('referenceNumber')?.hasError('required')
                  "
                >
                  Enter reference number
                </span>
                <span
                  class="p-error"
                  style="font-size: 0.8rem"
                  *ngIf="
                    composeForm.get('referenceNumber')?.hasError('maxlength')
                  "
                >
                  *Maximum 80 characters allowed
                </span>
                <span
                  class="p-error"
                  style="font-size: 0.8rem"
                  *ngIf="
                    composeForm
                      .get('referenceNumber')
                      ?.hasError('invalidChars') &&
                    composeForm.get('referenceNumber')?.touched
                  "
                >
                  *Only alphabets, numbers, _ and - are allowed
                </span>
              </div>
            </div>
          </div>
        </form>

        <!-- ── Compose Documents section ── -->
        <div class="compose-section-header mt-4 mb-1">
          <h5 class="title_five mb-0 me-2">Compose Documents</h5>
          <span class="compose-new-badge">NEW</span>
        </div>
        <p class="text_p mb-3">
          Add one or more PDFs, images, or templates and arrange them into a
          single order before proceeding — same as CAT Upload, now available as
          a standalone service.
        </p>

        <!-- Drop zone -->
        <div
          class="compose-dropzone"
          [class.drag-over]="isDragging"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="compose-dropzone-inner">
            <div class="compose-upload-circle">
              <i class="bx bx-upload"></i>
            </div>
            <p class="text-muted mb-2" style="font-size: 0.875rem">
              Drop your files here or
            </p>

            <!-- Upload split-button + two-panel dropdown -->
            <div
              class="compose-upload-wrapper"
              appClickOutside
              (clickOutside)="closeDropdown()"
            >
              <button
                class="compose-upload-btn"
                type="button"
                aria-haspopup="true"
                [attr.aria-expanded]="showDropdown"
                (click)="toggleDropdown()"
              >
                Upload &nbsp;<i
                  class="bx bx-chevron-down"
                  aria-hidden="true"
                ></i>
              </button>

              <!-- ── Two-panel upload menu ── -->
              <div
                class="compose-dropdown upload-menu"
                *ngIf="showDropdown"
                role="dialog"
                aria-label="Upload options"
                (click)="$event.stopPropagation()"
              >
                <div class="compose-dropdown-body">
                  <!-- LEFT panel: fixed 200px — file upload buttons -->
                  <div class="compose-panel menu-col menu-col-left">
                    <div class="compose-panel-title menu-label">
                      <i class="bx bx-folder-open" aria-hidden="true"></i>Add a
                      file
                    </div>

                    <!-- PDF upload button -->
                    <div
                      class="compose-option upload-file-btn"
                      role="button"
                      tabindex="0"
                      data-kind="pdf"
                      aria-label="Upload PDF from Desktop"
                      [class.uploading]="pdfUploading"
                      [attr.aria-busy]="pdfUploading"
                      (click)="!pdfUploading && triggerPdfInput()"
                      (keydown.enter)="!pdfUploading && triggerPdfInput()"
                      (keydown.space)="!pdfUploading && triggerPdfInput()"
                    >
                      <div
                        class="compose-opt-icon compose-opt-pdf"
                        aria-hidden="true"
                      >
                        <i
                          class="bx"
                          [ngClass]="
                            pdfUploading
                              ? 'bx-loader-alt bx-spin'
                              : 'bxs-file-pdf'
                          "
                        >
                        </i>
                      </div>
                      <div>
                        <div class="compose-opt-label">
                          {{
                            pdfUploading
                              ? "Uploading PDFs…"
                              : "Upload PDF from Desktop"
                          }}
                        </div>
                        <div class="compose-opt-sub">
                          Multiple files in one action
                        </div>
                      </div>
                    </div>

                    <!-- Image upload button -->
                    <div
                      class="compose-option upload-file-btn"
                      role="button"
                      tabindex="0"
                      data-kind="image"
                      aria-label="Upload Image (JPG/PNG)"
                      [class.uploading]="imageUploading"
                      [attr.aria-busy]="imageUploading"
                      (click)="!imageUploading && triggerImageInput()"
                      (keydown.enter)="!imageUploading && triggerImageInput()"
                      (keydown.space)="!imageUploading && triggerImageInput()"
                    >
                      <div
                        class="compose-opt-icon compose-opt-img"
                        aria-hidden="true"
                      >
                        <i
                          class="bx"
                          [ngClass]="
                            imageUploading
                              ? 'bx-loader-alt bx-spin'
                              : 'bxs-image'
                          "
                        >
                        </i>
                      </div>
                      <div>
                        <div class="compose-opt-label">
                          {{
                            imageUploading
                              ? "Uploading images…"
                              : "Upload Image (JPG / PNG)"
                          }}
                        </div>
                        <div class="compose-opt-sub">
                          JPG, JPEG, PNG — multiple in one action
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Vertical 1px divider -->
                  <div
                    class="compose-panel-divider menu-col-divider"
                    role="separator"
                  ></div>

                  <!-- RIGHT panel: flexible — template search + list -->
                  <div class="compose-panel menu-col menu-col-right">
                    <div
                      class="compose-panel-title menu-label d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <i class="bx bxs-file-doc" aria-hidden="true"></i>Use
                        atemplate
                      </div>
                      <button
                        type="button"
                        class="btn p-0 border-0 bg-transparent"
                        (click)="closeDropdown()"
                        aria-label="Close"
                      >
                        <i class="bx bx-x fs-5"></i>
                      </button>
                    </div>

                    <!-- Search box -->
                    <div class="compose-search-wrap mb-2">
                      <i
                        class="bx bx-search compose-search-icon"
                        aria-hidden="true"
                      ></i>
                      <input
                        class="compose-search-input"
                        type="search"
                        placeholder="Search templates…"
                        aria-label="Search templates"
                        [value]="templateSearchText"
                        (input)="onTemplateSearch($event)"
                      />
                    </div>

                    <!-- Template list -->
                    <div
                      class="compose-tmpl-list"
                      role="listbox"
                      aria-label="Available templates"
                    >
                      <!-- Loading state -->
                      <div
                        *ngIf="isLoadingTemplates"
                        class="compose-empty"
                        aria-live="polite"
                      >
                        <i
                          class="bx bx-loader-alt bx-spin"
                          aria-hidden="true"
                        ></i>
                        <span>Loading templates…</span>
                      </div>

                      <ng-container *ngIf="!isLoadingTemplates">
                        <!-- Template items -->
                        <div
                          *ngFor="let t of filteredTemplates"
                          class="compose-tmpl-item"
                          [class.selected]="isTemplateSelected(t.id)"
                          role="option"
                          tabindex="0"
                          [attr.aria-selected]="isTemplateSelected(t.id)"
                          (click)="selectTemplate(t)"
                          (keydown.enter)="selectTemplate(t)"
                          (keydown.space)="selectTemplate(t)"
                        >
                          <i
                            class="bx bxs-file-doc me-2 text-primary"
                            aria-hidden="true"
                          ></i>
                          <span>{{ t.name }}</span>
                          <i
                            class="bx bx-check ms-auto text-success fw-bold"
                            aria-hidden="true"
                            *ngIf="isTemplateSelected(t.id)"
                          ></i>
                        </div>

                        <!-- Empty state -->
                        <div
                          *ngIf="filteredTemplates.length === 0"
                          class="compose-empty"
                          role="status"
                          aria-live="polite"
                        >
                          <i class="bx bx-search-alt" aria-hidden="true"></i>
                          <span>{{
                            templateSearchText
                              ? "No templates match your search"
                              : "No templates available"
                          }}</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Hidden file inputs -->
        <input
          #pdfInput
          type="file"
          multiple
          accept=".pdf"
          hidden
          (change)="onPdfSelected($event)"
        />
        <input
          #imageInput
          type="file"
          multiple
          accept=".jpg,.jpeg,.png"
          hidden
          (change)="onImageSelected($event)"
        />
      </div>
    </div>

    <!-- ── Document order cards ─────────────────────────────────────────────── -->
    <div class="card card_outLine mt-3" *ngIf="selectedDocuments.length > 0">
      <div class="card-body">
        <div class="compose-order-header">
          <span class="title_five">Document order</span>
          <span class="compose-order-hint"> Drag cards to change order</span>
        </div>

        <!-- Cards row -->
        <div
          class="compose-cards-row"
          cdkDropList
          cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="compose-doc-card clickable"
            *ngFor="let doc of selectedDocuments; let i = index"
            cdkDrag
            [cdkDragDisabled]="doc.type === 'template'"
            (click)="openDocPreview(doc)"
            style="cursor: pointer;"
            pTooltip="Click to preview document"
            tooltipPosition="top"
          >
            <div class="compose-card-badge">{{ i + 1 }}</div>

            <div
              class="drag-handle"
              cdkDragHandle
              *ngIf="doc.type !== 'template'"
              (click)="$event.stopPropagation()"
            >
              <i class="bx bx-grid-vertical"></i>
            </div>

            <button class="compose-card-remove" (click)="removeDoc(doc.id); $event.stopPropagation()">
              <i class="bx bx-trash"></i>
            </button>
            <div class="compose-card-preview">
              <i [class]="'bx ' + iconFor(doc.type)"></i>
            </div>
            <div class="compose-card-name" [title]="doc.name">
              {{ doc.name }}
            </div>
            <div class="compose-card-pages" *ngIf="doc.pageCount">
              {{ doc.pageCount }} pages
            </div>
          </div>

          <!-- Add another tile -->
          <div
            class="compose-add-card"
            (click)="toggleDropdown(); $event.stopPropagation()"
          >
            <i class="bx bx-plus"></i><span>Add another</span>
          </div>
        </div>

        <!-- Final send order bar -->
        <div class="compose-order-bar mt-3">
          <span class="compose-order-label">Final send order:&nbsp;</span>
          <ng-container *ngFor="let doc of selectedDocuments; let i = index">
            <span
              class="compose-order-item"
              style="color: #612e86; font-weight: 500"
            >
              {{ i + 1 }}. {{ doc.name }}
            </span>
            <span
              *ngIf="i < selectedDocuments.length - 1"
              class="compose-order-sep"
              >&nbsp;›&nbsp;</span
            >
          </ng-container>
        </div>

        <!-- Action buttons -->
        <div class="compose-actions mt-3">
          <p-button
            label="Next: Edit Template"
            styleClass="p-button-sm-outline"
            [disabled]="selectedDocuments.length === 0"
            (click)="onNextClick()"
          ></p-button>
        </div>
      </div>
    </div>

    <!-- Next button when no cards yet -->
    <div class="text-right mt-3" *ngIf="selectedDocuments.length === 0">
      <p-button
        label="Next"
        styleClass="p-button-sm-outline"
        [disabled]="selectedDocuments.length === 0"
        (click)="onNextClick()"
      ></p-button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       STEP 2 — Edit Template  (same shared component as cat-edit)
       ══════════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="showEditTemplate">
    <app-template-edit
      [editTemplateData]="sendEditTemplateData"
      (editTemplateChange)="oneditTemplateChange($event)"
    >
    </app-template-edit>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       STEP 3 — E-stamp
       ══════════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="showEstampDetails">
    <app-estamp-details
      [estampData]="estampData"
      (estampChange)="onestampDataChange($event)"
    >
    </app-estamp-details>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       STEP 4 — Signing
       ══════════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="showEsignDetails">
    <app-e-sign-details
      [esignData]="esignData"
      [showESignOptions]="true"
      (esignDataChange)="onesignDataChange($event)"
    >
    </app-e-sign-details>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       STEP 5 — Order Confirmation
       ══════════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="showConfirmation">
    <app-order-confirmation-details
      #orderDetails
      [orderConfirmationData]="orderConfirmationData"
      (orderConfirmationChange)="onOrderConfirmationChange($event)"
    >
    </app-order-confirmation-details>
  </div>
</div>

<div class="toast_display_layer"><p-toast></p-toast></div>

<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>

<!-- ── Review Order modal ── -->
<ng-template #reviewOrder let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <app-review-order-details
        [reviewOrderData]="reviewOrderData"
        (reviewOrderDataChange)="reviewOrderDataChange($event)"
      >
      </app-review-order-details>
    </div>
  </div>
</ng-template>

<!-- ── Payment modal ── -->
<ng-template #paymentScreen let-modal>
  <div class="modal-header">
    <strong *ngIf="paymentDetails?.paymentMethod !== 'wallet'"
      >Payment Details</strong
    >
    <strong *ngIf="paymentDetails?.paymentMethod === 'wallet'"
      >Payment Details (Wallet)</strong
    >
    <button
      type="button"
      class="btn-close"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <app-payment-order
        [paymentOrderData]="paymentOrderData"
        (paymentOrderDataChange)="paymentOrderDataChange($event)"
      >
      </app-payment-order>
    </div>
  </div>
</ng-template>

<app-document-preview-modal
  [isVisible]="previewModalVisible"
  (isVisibleChange)="onPreviewVisibilityChange($event)"
  [file]="previewFile"
  [files]="previewModalFiles"
  [pdfSrc]="previewPdfSrc"
  [fileName]="previewFileName"
  [fileType]="previewFileType"
  [imageUrl]="previewImageUrl"
  [htmlContent]="previewHtmlContent"
  [mode]="previewModalMode"
  [isTemplate]="previewIsTemplate || activePreviewDoc?.type === 'template' || !!activePreviewDoc?.templateId"
  (onUpload)="onComposeUploadConfirmed($event)"
  (onCancel)="onComposeUploadCancelled()"
  (onSave)="onComposeFileSaved($event)"
>
</app-document-preview-modal>
